
import { defineComponent } from "vue";

const __default__ = defineComponent({
  props: {
    text: {
      type: [String, Number],
      default: ""
    },
    subText: {
      type: [String, Number]
    },
    label: {
      type: String,
      default: ""
    },
    alignment: {
      type: String,
      default: "center"
    }
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "3d91a26a": (_ctx.alignment)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__